import { render } from "./TheMeasuresChartView.vue?vue&type=template&id=33dc2a60&scoped=true&ts=true"
import script from "./TheMeasuresChartView.vue?vue&type=script&lang=ts"
export * from "./TheMeasuresChartView.vue?vue&type=script&lang=ts"

import "./TheMeasuresChartView.vue?vue&type=style&index=0&id=33dc2a60&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dc2a60"]])

export default __exports__